var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Box, Card, CardMedia, Stack, Typography, } from '@mui/material';
import designTokens from '@customink/design-tokens/build/ci_light/js/designTokens';
import { StarFilledIcon } from '../../icons';
var ProductRecommendationCard = function (_a) {
    var title = _a.title, price = _a.price, rating = _a.rating, imgSrc = _a.imgSrc, imgSrcSet = _a.imgSrcSet, imgAlt = _a.imgAlt, imgLoading = _a.imgLoading, itemCount = _a.itemCount, ratingsCount = _a.ratingsCount, minOrderQuantity = _a.minOrderQuantity, onClick = _a.onClick, rest = __rest(_a, ["title", "price", "rating", "imgSrc", "imgSrcSet", "imgAlt", "imgLoading", "itemCount", "ratingsCount", "minOrderQuantity", "onClick"]);
    return (React.createElement(Card, __assign({ onClick: onClick, sx: __assign({ width: '100%', display: 'flex', flexDirection: 'column' }, (onClick
            ? {
                cursor: 'pointer',
                '&:hover': {
                    borderColor: designTokens.color.gray.accent.value,
                    boxShadow: '0px 4px 8px 0px rgba(0, 0, 0, 0.15)',
                },
                '&:active': {
                    boxShadow: '0px 1px 3px 0px rgba(0, 0, 0, 0.15)',
                },
            }
            : {
                '&:hover': {
                    borderColor: designTokens.color.gray.accent.value,
                    boxShadow: 'none',
                },
            })) }, rest),
        React.createElement(CardMedia, { component: "img", sx: { aspectRatio: '1/1', maxHeight: '16rem' }, src: imgSrc, srcSet: imgSrcSet, alt: imgAlt, loading: imgLoading, draggable: false }),
        React.createElement(Stack, { sx: { p: '16px', pt: '12px', flexGrow: 1, gap: '4px' } },
            React.createElement(Typography, { variant: "heading6", sx: {
                    textOverflow: 'ellipsis',
                    overflow: 'hidden',
                    color: designTokens.color.gray.obsidian.value,
                    display: '-webkit-box',
                    WebkitLineClamp: 4,
                    WebkitBoxOrient: 'vertical',
                    letterSpacing: '-0.14px',
                    flexGrow: 1,
                } }, title),
            React.createElement(Box, { sx: {
                    display: 'flex',
                    alignItems: 'center',
                    flexDirection: 'row',
                    gap: '2px',
                    ml: '-2px',
                } },
                React.createElement(StarFilledIcon, { sx: {
                        color: designTokens.color.yellow.default.value,
                        fontSize: '20px',
                    } }),
                React.createElement(Typography, { sx: {
                        fontSize: '14px',
                        lineHeight: '16px',
                        fontWeight: 500,
                        color: designTokens.color.gray.obsidian.value,
                        pt: '1px',
                    } }, rating),
                React.createElement(Typography, { sx: {
                        fontSize: '12px',
                        lineHeight: '16px',
                        fontWeight: 500,
                        color: designTokens.color.gray.limestone.value,
                        pt: '1px',
                    } },
                    "(",
                    ratingsCount,
                    ")")),
            React.createElement(Typography, { variant: "uiTextSmall", sx: {
                    color: designTokens.color.gray.obsidian.value,
                } },
                "Minimum ",
                minOrderQuantity),
            React.createElement(Typography, { variant: "uiTextTiny", sx: {
                    letterSpacing: '-0.3px',
                    color: designTokens.color.gray.slateDefault.value,
                } },
                price,
                " each for ",
                itemCount,
                "\u00A0items"))));
};
export default ProductRecommendationCard;
//# sourceMappingURL=ProductRecommendationCard.js.map